import { formatRubles } from "src/util";

export interface BaseDiscountResult {
  originalPrice: string;
  discountPercent: number;
  timeLeft: number;
  isExpired: boolean;
}

interface Params {
  isActive: boolean;
  isExpired: boolean;
  fetchedPrice: number | undefined;
  discountPercent: number;
  timeLeft: number;
}

const formatPrice = (price: number) => `${formatRubles(price)} / Месяц`;

/**
 * Вычисляет параметры скидки для базового тарифа.
 *
 * Цена из API считается уже скидочной. Оригинальная цена (до скидки)
 * рассчитывается обратно: originalPrice = fetchedPrice / (1 - discount%).
 * Она отображается зачёркнутой рядом с текущей ценой.
 *
 * Возвращает undefined, если скидка неактивна или цена ещё не загружена.
 * Если isExpired = true — скидка показывается, но таймер скрыт.
 */
export const getBaseDiscount = ({
  isActive,
  isExpired,
  fetchedPrice,
  discountPercent,
  timeLeft,
}: Params): BaseDiscountResult | undefined => {
  if (!isActive || fetchedPrice === undefined) return undefined;

  const originalPriceAmount = Math.round(
    fetchedPrice / (1 - discountPercent / 100),
  );

  return {
    originalPrice: formatPrice(originalPriceAmount),
    discountPercent,
    timeLeft,
    isExpired,
  };
};
